import {combineEpics} from 'redux-observable';

import blockEpics from './blockEpics';
import blockResultEpics from './blockResultEpics';
import viewEpics from './viewEpics';
import workflowEpics from './workflowEpics';
import databaseEpics from './databaseEpics';
import dataTreeEpics from './dataTreeEpics';
import viewTreeEpics from './viewTreeEpics';
import webhookEpics from './webhookEpics';
import noteflowEpics from './noteflowEpics';
import noteflowTaskEpics from './noteflowTaskEpics';
import schemaEpics from './schemaEpics';
import sharingSettingsEpics from './sharingSettingsEpics';
import tableEpics from './tableEpics';
import tableauEpics from './tableauEpics';
import userEpics from './userEpics';
import roleEpics from './roleEpics';
import reportEpics from './reportEpics';
import reportResultEpics from './reportResultEpics';
import organizationEpics from './organizationEpics';
import workspaceEpics from './workspaceEpics';
import workspaceConfigEpics from './workspaceConfigEpics';
import searchEpics from './searchEpics';
import subscriptionEpics from './subscriptionEpics';
import activityEpics from './activityEpics';
import editorEpics from './editorEpics';
import unsplashEpics from './unsplashEpics';
import folderEpics from './folderEpics';
import favoriteEpics from './favoriteEpics';
import integrationEpic from './integrationEpics'
import s3ConnectionEpic from './s3ConnectionEpics';
import tagEpics from './tagEpics';
import savedBlockEpics from './savedBlockEpics';
import dataRetentionEpics from './dataRetentionEpics';
import codeBlockEpics from "./codeBlockEpics";


export const rootEpic = combineEpics(
  blockEpics,
  blockResultEpics,
  databaseEpics,
  dataTreeEpics,
  viewEpics,
  workflowEpics,
  webhookEpics,
  noteflowEpics,
  noteflowTaskEpics,
  viewTreeEpics,
  schemaEpics,
  sharingSettingsEpics,
  subscriptionEpics,
  tableEpics,
  tableauEpics,
  userEpics,
  roleEpics,
  reportEpics,
  reportResultEpics,
  organizationEpics,
  workspaceEpics,
  workspaceConfigEpics,
  searchEpics,
  tagEpics,
  activityEpics,
  editorEpics,
  folderEpics,
  unsplashEpics,
  favoriteEpics,
  integrationEpic,
  s3ConnectionEpic,
  savedBlockEpics,
  dataRetentionEpics,
  codeBlockEpics,
);
